import type { DocumentWorkspaceContext } from "~/types/documents";

export function getDocumentsBasePath(
  context: DocumentWorkspaceContext,
): string {
  return context === "school"
    ? "/school-dashboard/documents"
    : "/dashboard/documents";
}

export function resolveDocumentRouteDestination(input: {
  allowed: boolean;
  organizationId: number | null;
  path: string;
  schoolManagement: boolean;
}): string | null {
  const context = input.organizationId ? "school" : "individual";
  if (!input.allowed)
    return input.schoolManagement ? "/school-dashboard" : "/dashboard/home";
  const base = getDocumentsBasePath(context);
  if (input.path === base || input.path.startsWith(`${base}/`)) return null;
  const oldBase = getDocumentsBasePath(
    context === "school" ? "individual" : "school",
  );
  const suffix = input.path.slice(oldBase.length);
  return context === "individual" && suffix === "/settings"
    ? base
    : `${base}${suffix}`;
}

export function isDocumentWorkspaceRoute(path: string): boolean {
  return [
    getDocumentsBasePath("individual"),
    getDocumentsBasePath("school"),
  ].some((base) => path === base || path.startsWith(`${base}/`));
}
